import script from "./WebhookManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./WebhookManagement.vue?vue&type=script&setup=true&lang=js"

import "./WebhookManagement.vue?vue&type=style&index=0&id=03b9233b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b9233b"]])

export default __exports__